var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PCSS, P, PropertyConverters, Watch, ViewChild, Components, CustomElement } from '@pacem/pacem-core';
let PacemPartialViewElement = class PacemPartialViewElement extends Components.PacemElement {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._syncView();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'url':
                case 'disabled':
                    this._syncView();
                    break;
            }
        }
    }
    _syncView() {
        this._view.disabled = this.disabled;
        this._view.url = this.url;
    }
};
__decorate([
    ViewChild(P + '-view')
], PacemPartialViewElement.prototype, "_view", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPartialViewElement.prototype, "url", void 0);
PacemPartialViewElement = __decorate([
    CustomElement({
        tagName: 'pacemjs-view', shadow: false, template: `<${P}-collapse class="${PCSS}-margin margin-bottom-3"><${P}-view></${P}-view></${P}-collapse>`
    })
], PacemPartialViewElement);
export { PacemPartialViewElement };
